import { Autocomplete, TextField, Typography } from "@mui/material";
import { ChangeEvent, FC } from "react";
import { collectUserOptionList } from "./collectOptionList";

interface IProps {
    isDisabled?: boolean;
    title: string;
    value: any | null;
    handleChangeValue: any;
    optionList: any[];
    isMultiline: boolean;
    changeText?: (event: ChangeEvent<HTMLInputElement>) => void;
};

export const UserAutocomplete: FC<IProps> = ({ value, handleChangeValue, optionList, title, changeText, isMultiline, isDisabled }) => {
    
    return (
        <Autocomplete
            disablePortal
            multiple={isMultiline}
            fullWidth
            onChange={(event, value) => handleChangeValue(value)}
            value={value}
            options={collectUserOptionList(optionList)}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            renderOption={(params, option): JSX.Element => (
                <Typography {...params} key={option.id} p={1}>
                    {option.name}
                </Typography>
            )}
            renderInput={(params): JSX.Element => (
                <TextField
                    {...params}
                    variant="outlined"
                    label={title}
                    onChange={changeText}
                />
            )}
            disabled={isDisabled}
        />
    )
};
